
  import { TodoRecord, Type } from '@/entities/todo';
  import { getPaginationForTodo, listTodo } from '@/services/api/resources/todo';
  import { openTodo } from '@/services/todo/todoService';
  import Widget, { CollapsibleProperties } from '@/ui/components/home/Widget.vue';
  import StaticPagination from '@/ui/components/StaticPagination.vue';
  import { ResourceTable } from '@/ui/components/table/ResourceTable';
  import { Tag } from '@/ui/components/Tag';
  import OverdueTag from '@/ui/components/tag/OverdueTag.vue';
  import { useLazyPagination, useTask } from '@/ui/concerns';
  import { useQueries } from '@/ui/pages/dashboard/useQueries';
  import { defineComponent, ref, watch } from 'vue';
  import { Loader } from '@/ui/components/Loader';

  const TODOS_COUNT = 5;

  export default defineComponent<CollapsibleProperties>({
    components: {
      Widget,
      OverdueTag,
      Tag,
      Loader,
      ResourceTable,
      Pagination: StaticPagination,
    },
    props: ['collapsible'],
    setup() {
      const todos = ref<TodoRecord[]>([]);
      const page = ref(1);
      const isEmpty = ref(false);

      const getTodosPagination = () => getPaginationForTodo(assignedToYouIssuesOrFormsQuery());

      const { assignedToYouIssuesOrFormsQuery } = useQueries();
      const { total, totalLoading, updateLazyPaginationOnDataFetch } = useLazyPagination(getTodosPagination);

      const getTodos = useTask(
        () => listTodo(assignedToYouIssuesOrFormsQuery({
          page: page.value,
          perPage: TODOS_COUNT,
        })),
        response => {
          todos.value = response.data;
          isEmpty.value = todos.value.length === 0;

          updateLazyPaginationOnDataFetch(response, TODOS_COUNT);
        },
      );

      const onPageChanged = (value: number) => {
        page.value = value;
      };

      watch([page], () => getTodos.run({ page: page.value }));

      return {
        getTodos,
        todos,
        page,
        perPage: TODOS_COUNT,
        total,
        totalLoading,
        onPageChanged,
        TYPE_ISSUE: Type.Issue,
        openTodo,
        isEmpty,
      };
    },
  });
